import React, { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { post } from '../httpService';
import Documentation from './api_doc/pay_in/payin_doc';

type FormValues = {
    phone: string;
    password: string;
};

const Login: React.FC = () => {

    const { register, handleSubmit, formState: { errors } } = useForm<FormValues>();
    const [isLoad, setIsLoad] = useState<boolean>(false);

    const [error, setError] = useState<String>("");

    const onSubmit: SubmitHandler<FormValues> = async (data) => {
        try {

            var postData = {
                phone_country_code: "+237",
                phone: data.phone,
                password: data.password
            };

            setError('');

            setIsLoad(true);

            post('/login', postData)
                .then((response) => {
                    console.log('Réponse GET :', response.data.data.token);
                    localStorage.setItem('authToken', response.data.data.token);
                    localStorage.setItem('authUser', JSON.stringify(response.data.data));
                    window.location.href = "/";
                })
                .catch((error) => {
                    setError('Téléphone ou mot de passe incorrect');
                    console.error('Erreur GET :', error);
                    setIsLoad(false);
                }
                );

        } catch (error) {
            console.error('Error logging in', error);
            setIsLoad(false);
            setError('Téléphone ou mot de passe incorrect');
        }
    };

    return (
        <div className="lg:flex justify-center items-center h-screen bg-white">
            <div className="lg:w-1/2 lg:h-full flex justify-center items-center">
                <div className="login px-5 py-10 m-8 w-full lg:p-10">
                    <a href="https://seremo.com" rel="noopener noreferrer">
                        <div className="absolute top-5  text-primary font-bold border-2 py-2 px-5 rounded-full cursor-pointer">Back on website</div>
                    </a>
                    <h2 className="text-2xl font-semibold mb-4 mt-10 lg:mt-0">Login</h2>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-4">
                            <input
                                type="text"
                                id="phone"
                                placeholder="Phone Number"
                                {...register('phone', { required: 'Phone number is required' })}
                                className="w-full mt-1 p-3 border rounded-lg"
                            />
                            {errors.phone && <p className="text-danger mt-1">{errors.phone.message}</p>}
                        </div>
                        <div className="mb-4">
                            <input
                                type="password"
                                id="password"
                                placeholder="Password"
                                {...register('password', { required: 'Password is required' })}
                                className="w-full mt-1 p-3 border rounded-lg"
                            />
                            {errors.password && <p className="text-danger mt-1">{errors.password.message}</p>}
                        </div>
                        {error != '' && <p className="text-danger mt-1">{error}</p>}
                        <div className="mb-6 mt-6">
                            <button
                                type="submit"
                                className="w-full py-4 px-4 text-white bg-primary rounded hover:bg-blue-600 focus:outline-none focus:shadow-outline-blue active:bg-blue-700"
                            >
                                {isLoad ? "Connexion en cours..." : "Login"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div className="lg:w-1/2 lg:h-full relative">
                <img
                    src="https://st3.depositphotos.com/1743476/32186/i/450/depositphotos_321867522-stock-photo-mature-african-businessman-at-meeting.jpg"
                    alt="Logo"
                    className="object-cover w-full h-full"
                />
                <div className="absolute inset-0 bg-primary opacity-50"></div>
                <div className="absolute bottom-10 left-0 p-4 text-white">
                    <h1 className="text-4xl font-bold">Seremo Business</h1>
                    <p className="text-xl font-semibold">Collect fund with Seremo Business</p>
                </div>
            </div>
        </div>
    );
};

export default Login;
